import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'petastiIson';
const args = {};

export class PetastiIson extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
